/**
 * "The conversation changed, so what is in the composer is not for the new one."
 *
 * The composer's paperclips live in React state inside `MultiAgentRoute` (`useAttachments`), out of reach of the
 * non-React code that switches conversations (`openConversation.ts`). This store is the signal between them: the
 * switch bumps `epoch`, the route clears its paperclips when it changes. Without it "New session" kept the old files and
 * every later send carried them.
 */
import { create } from "zustand";

interface ComposerResetState {
  epoch: number;
  bump: () => void;
}

export const useComposerResetStore = create<ComposerResetState>((set) => ({
  epoch: 0,
  bump: () => set((s) => ({ epoch: s.epoch + 1 })),
}));

/**
 * True once per bump: the route compares the epoch it last saw with the current one. A mount (seen starts at the
 * current epoch) is not a change, so opening the page never clears anything.
 */
export function consumeComposerEpoch(seen: { current: number }, epoch: number): boolean {
  if (seen.current === epoch) return false;
  seen.current = epoch;
  return true;
}
